#import "../../select/fragments/lead-basic.graphql"

query GetRelatedEntities($input: PotentialEntitiesInput!) {
    potentialRelatedEntities(input: $input) {
        contacts {
            id
            name
        }
        accounts {
            id
            name
        }
        leads {
            ...LeadBasic
        }
        users {
            id
            name
        }
    }
}
